import { render, staticRenderFns } from "./expressFund.vue?vue&type=template&id=2636d8da&scoped=true&"
import script from "./expressFund.vue?vue&type=script&lang=js&"
export * from "./expressFund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2636d8da",
  null
  
)

export default component.exports